import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../lib/utils.js';
export const Badge = ({ className, variant = 'default', children, ...props }) => {
    const baseStyles = 'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 select-none';
    const variantStyles = {
        default: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-300',
        secondary: 'bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-300',
        success: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300',
        warning: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
        destructive: 'bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-300',
        outline: 'border border-slate-300 text-slate-700 dark:border-slate-700 dark:text-slate-300',
    };
    return (_jsx("div", { className: cn(baseStyles, variantStyles[variant], className), ...props, children: children }));
};
Badge.displayName = 'Badge';
//# sourceMappingURL=Badge.js.map